import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthState, getAuthState } from 'app/main/auth/store/auth.reducer';
import { PrivilegeEnum } from 'app/main/privilege/privilege.enum';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

export const CONTROLE_ACCES = 'CONTROLE_ACCES'
export const PARAMETRER_APP = 'PARAMETRER_APP'

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private _router: Router, private _store: Store<AuthState>) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean | UrlTree> {
        return this._store.select(getAuthState)
            .pipe(
                filter(data => data.loadedAt != null),
                take(1),
                map(data => {
                    if (route.data && route.data.privilege) {
                        /* console.log("route.data"+route.data);
                        console.log("route.data.privilege"+route.data.privilege); */
                        if (data.authData.authorities.includes(route.data.privilege)) {
                            return true;
                        } else {
                            return this._router.parseUrl('/403');
                        }
                    } else {
                        // begin( provisoire + refactoring )
                        if (data.loggedIn && data.authData.authorities.length == 1 && data.authData.authorities[0] == PrivilegeEnum.FEEDBACK) {
                            return this._router.parseUrl('/feedback');
                        }
                        // end( provisoire + refactoring )
                        return data.loggedIn;
                    }
                })
            )
    }
}
